import React, { useRef, useState, useContext } from 'react';
import { AppContext } from "../../util/AppContext";
import { getConfigValue } from "../../util/getConfigValue";
import PropType from 'prop-types';
import Tooltip from '../Tooltip';

LeaderTableCard.propTypes = {
    userReportData: PropType.array,
    isLoading: PropType.bool

};
function LeaderTableCard({ userReportData, isLoading }) {
    const [appState] = useContext(AppContext);
    const cardEnabled = getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.Enabled, appState)?.Value === 'true' || false;
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipTarget = useRef(null);

    return (
        <>
            {cardEnabled &&
                <div className="card pd-card p-4 chartCardContainer mb-4 mt-5">
                    <div className="row justify-content-center">
                        {isLoading ? (
                            <div className="col-1 col-md-1 mb-0 mb-md-0">
                                <p>{getConfigValue(appState.config.Common?.Loading, appState)?.Value}</p>
                            </div>
                        ) : (
                            <div className='d-flex flex-column '>
                                <div className='d-inline-flex w-100'>
                                    <table className='table pd-table'>
                                        <thead className='table-blue'>
                                            <tr>
                                                <th>{getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.Columns?.First, appState)?.Value || "Rank"}
                                                    <span ref={tooltipTarget} 
                                                    role="tooltip"
                                                    onMouseOver={() => setShowTooltip(true)} 
                                                    onMouseOut={() => setShowTooltip(false)} 
                                                    onFocus={() => setShowTooltip(true)}
                                                    onBlur={() => setShowTooltip(false)}
                                                    className="fas fa-info-circle ps-2"></span>
                                                    <Tooltip
                                                        text={`${getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.Columns?.First?.Tooltip, appState)?.Value}`}
                                                        ref={tooltipTarget}
                                                        showTooltip={showTooltip}
                                                    /></th>
                                                <th>{getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.Columns?.Second, appState)?.Value || "Name"}</th>
                                                <th className='text-end pe-5'>{getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.Columns?.Third, appState)?.Value || "PDFs Generated"}</th>
                                                <th className='text-end pe-5'>{getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.Columns?.Fourth, appState)?.Value || "Number of Logins"}</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-row'>
                                            {userReportData && userReportData.length > 0 ? (
                                                userReportData.map((user, index) => (
                                                    <tr key={index} className={`${appState.user.toLowerCase() === user.userEmailAddress.toLowerCase() ? "highlight" : ""}`}>
                                                        <td>{user.ordinal}</td>
                                                        <td>
                                                            {(user.firstName.trim() || user.lastName.trim())
                                                                ? `${user.firstName} ${user.lastName}`
                                                                : user.userEmailAddress}
                                                        </td>
                                                        <td className="text-end pe-5">{user.totalPdfCount}</td>
                                                        <td className="text-end pe-5">{user.totalLoginCount}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className='text-center'>{getConfigValue(appState?.config?.Commmon?.NoData, appState)?.Value || 'No data available'}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        )}
                    </div>
                </div>
            }
        </>
    );
}

export default LeaderTableCard;
